import { render, staticRenderFns } from "./BRSModal.vue?vue&type=template&id=873d1d1e&scoped=true&"
import script from "./BRSModal.vue?vue&type=script&lang=ts&"
export * from "./BRSModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873d1d1e",
  null
  
)

export default component.exports